import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Dialog } from 'primereact/dialog'
import { Fetch } from '../../shared/Fetch'
import { IModal } from './TestCases'
import { emptyFormData, IFormData } from './Form'
import { useLocation } from 'react-router-dom'
import { Filter, FilterValues, initialFilter } from "./Filter";

interface Iprops {
    toast: any,
    setModal: (modal: IModal) => void,
    reload: boolean,
    hasPermission: (pageName: string, featureName?: string) => Boolean,
}
// interface ILazyParams {
//     first: number;
//     rows: number;
//     page: number;
//     sortField: string;
//     sortOrder: SortOrder;
// }

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState<IFormData[]>([]);
    const [stepsDialogVisible, setStepsDialogVisible] = useState(false);
    const [stepsList, setStepsList] = useState<{ step: string, description: string }[]>([]);
    const [preconditionsDialogVisible, setPreconditionsDialogVisible] = useState(false);
    const [preconditionsList, setPreconditionsList] = useState<{ step: string, description: string }[]>([]);
    const [filterDialogVisible, setFilterDialogVisible] = useState(false );
    const [filter, setFilter] = useState<FilterValues>(initialFilter);
    const [filter2, setFilter2] = useState<boolean>(false);

    const location = useLocation();
    const projectId = location.state?.projectId || null;

    useEffect(() => {
        if (projectId) {
            props.setModal({ open: true, singleData: { ...emptyFormData, projectID: location.state.projectId } });
        }
    }, [location.state]);

    const Action = (rowData: IFormData) => {
        return (
            <Button
                icon="pi pi-pen-to-square"
                className="p-button-rounded p-button-secondary p-button-text"
                onClick={() => openEditModel(rowData)}
            />
        );
    };

    const openEditModel = (rowData: IFormData) => {
        props.setModal({ open: true, singleData: rowData });
    };

    const leftToolbarTemplate = () => <p className="mt-2  text-xl">Test Cases List</p>;

    const rightToolbarTemplate = () => (
        <div className="my-2">
            <Button label="Add Test Cases" icon="pi pi-plus" className="p-button mr-2 mt-1" onClick={postTestCase} />
        </div>
    );

    const postTestCase = () => {
        props.setModal({ open: true, singleData: emptyFormData });
    };

    const LoadTableData = async () => {
        const response = await Fetch("TestCases", "GET", null, `filters=${JSON.stringify(filter)}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData(data);
        } else {
            props.toast.current.show({ severity: 'error', detail: "Failed to Load data", life: 3000 });
        }
    };

    useEffect(() => {
        LoadTableData();
    }, [props.reload, filter]);

    const toggleStatus = async (id?: number) => {
        const response = await Fetch("TestCases/togglestatus", "PUT", null, `testCase_ID=${id}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Status Changed", life: 3000 });
            LoadTableData();
        }
    };

    const TestCaseStatus = (rowData: IFormData) => (
        <span
            style={{ color: rowData.status ? 'blue' : 'red' }}
            className="cursor-pointer"
            onClick={() => toggleStatus(rowData.id)}
        >
            {rowData.status ? "Pass" : "Fail"}
        </span>
    );

    const TestCaseType = (rowData: IFormData) => (
        <span
            style={{ color: rowData.testType ? 'blue' : 'red' }}
            className="cursor-pointer"
            onClick={() => toggleType(rowData.id)}
        >
            {rowData.testType ? "Positive" : "Negative"}
        </span>
    );

    const toggleType = async (id?: number) => {
        const response = await Fetch("TestCases/toggleType", "PUT", null, `testCase_ID=${id}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Test Type Changed", life: 3000 });
            LoadTableData();
        }
    };

    const StepsCell = (rowData: IFormData) => (
        <span
            style={{ color: '#43a8f0ff', fontWeight: 500 }}
            className="cursor-pointer"
            onClick={() => {
                const stepsArray = rowData.stepsToExecute.split(",").map((desc, index) => ({
                    step: `Step ${index + 1}`,
                    description: desc.trim()
                }));
                setStepsList(stepsArray);
                setStepsDialogVisible(true);
            }}
        >
            View Steps ({rowData.stepsToExecute.split(",").length})
        </span>
    );

    const PreconditionsCell = (rowData: IFormData) => {
        if (!rowData.preconditions) return null;
        return (
            <span
                style={{ color: '#43a8f0ff', fontWeight: 500 }}
                className="cursor-pointer"
                onClick={() => {
                    const preconditionsArray = rowData.preconditions.split(",").map((desc, index) => ({
                        step: `Step ${index + 1}`,
                        description: desc.trim()
                    }));
                    setPreconditionsList(preconditionsArray);
                    setPreconditionsDialogVisible(true);
                }}
            >
                View Preconditions ({rowData.preconditions.split(",").length})
            </span>
        );
    };

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-lg text-900 ">Filter Test Cases</span>
            <div className="flex align-items-end gap-2">
                <Button icon="pi pi-filter" rounded raised className="p-button-text h-2rem" onClick={() => setFilterDialogVisible(true)} tooltip="Filter" tooltipOptions={{ position: 'top' }} />
            </div>
        </div>
    );

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Dialog header="Filter Employee" visible={filterDialogVisible} style={{ width: '40vw', height: '90vh' }} onHide={() => setFilterDialogVisible(false)} draggable={false} resizable={false} position="right">
                <Filter filter={filter} setFilter={(f: FilterValues) => { setFilter(f); setFilter2(!filter2); setFilterDialogVisible(false); }} />
            </Dialog>
            <DataTable
                style={{ fontSize: "15px" }}
                value={tableData}
                lazy
                dataKey="id"
                size="small"
                tableStyle={{ minWidth: "50rem" }}
                showGridlines
                header={header}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="projectName" header="Project Name" />
                <Column field="module" header="Module" />
                <Column field="subModule" header="Sub Module" />
                <Column field="scenario" header="Scenario" />
                <Column field="description" header="Description" />
                <Column field="testType" header="Test Type" body={TestCaseType} />
                <Column field="stepsToExecute" header="Steps To Execute" body={StepsCell} />
                <Column field="preconditions" header="Preconditions" body={PreconditionsCell} />
                <Column field="expectedResult" header="Expected Result" />
                <Column field="actualResult" header="Actual Result" />
                <Column field="status" header="Status" body={TestCaseStatus} />
                <Column field="comment" header="Comment" />
                <Column body={Action} header="Action" />
            </DataTable>

            {/* Dialog for Steps */}
            <Dialog
                header="Steps To Execute"
                visible={stepsDialogVisible}
                style={{ width: '40vw' }}
                onHide={() => setStepsDialogVisible(false)}
            >
                <DataTable value={stepsList} showGridlines>
                    <Column field="step" header="Step" />
                    <Column field="description" header="Description" />
                </DataTable>
            </Dialog>

            {/* Dialog for Preconditions */}
            <Dialog
                header="Preconditions"
                visible={preconditionsDialogVisible}
                style={{ width: '40vw' }}
                onHide={() => setPreconditionsDialogVisible(false)}
            >
                <DataTable value={preconditionsList} showGridlines>
                    <Column field="step" header="Step" />
                    <Column field="description" header="Description" />
                </DataTable>
            </Dialog>
        </>
    );
};
